export default __webpack_public_path__ + "images/0x43f9a13675e352154f745d6402e853fecc388aa5.png";